import { Injectable } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  constructor(private deviceService: DeviceDetectorService) {}

  public setDevice(): Observable<any> {
    const data = {
      isDesktop: this.deviceService.isDesktop(),
      isMobile: this.deviceService.isMobile(),
      isTablet: this.deviceService.isTablet(),
    };
    const type = data.isDesktop ? 'desktop' : data.isMobile ? 'mobile' : 'tablet';
    const payload: any = {
      info: this.deviceService.getDeviceInfo(),
      type,
      ...data,
    };
    return of(payload);
  }
}
